export default __webpack_public_path__ + "static/media/slots-hover.e7c6fb37.webp";